import { ICommonTranslations } from '@/translations/default/common';

const common: Partial<ICommonTranslations> = {
  exhibitors: 'Aussteller',
  exhibitor: 'Aussteller',
  product_interactions: 'Bewerbungen für Jobangebote',
};

export default common;
